export enum ToastMessages {
    ERROR_GENERIC = 'Er is een fout opgetreden. Probeer het opnieuw.',
    ERROR_FETCHING_DATA = 'Fout bij het ophalen van gegevens.',
    INFO_NO_DATA = 'Geen gegevens gevonden.',
    DATA_NOT_MODIFIED = 'Gegevens zijn niet gewijzigd.',

    ACCOUNT_DATA_SAVED = 'Accountgegevens succesvol opgeslagen.',
    ACCOUNT_DATA_NOT_SAVED = 'Accountgegevens konden niet worden opgeslagen.'
}